import {keyboardHandler} from '@containers/hooks'

type HandlerType = boolean | void | Promise<boolean | void>
export interface KeyboardHandlersType {
  enter?: () => HandlerType
  escape?: () => HandlerType
  anyKey?: (opts: {
    key: string
    keyCode: number
    shift: boolean
    alt: boolean
    ctrl: boolean
    meta: boolean
    code: string
  }) => HandlerType
}

export class KeyboardHandlers {
  private static initialized = false
  private static keydownHandlers: KeyboardHandlersType[] = []
  private static keyupHandlers: KeyboardHandlersType[] = []

  static init(): void {
    if (KeyboardHandlers.initialized) {
      return
    }
    KeyboardHandlers.initialized = true
    document.addEventListener('keydown', KeyboardHandlers.keydownListeners())
    document.addEventListener('keyup', KeyboardHandlers.keyupListeners())
  }

  static addKeydown(handlers: KeyboardHandlersType): void {
    KeyboardHandlers.keydownHandlers.push(handlers)
  }

  static removeKeydown(handlers: KeyboardHandlersType): void {
    const i = KeyboardHandlers.keydownHandlers.findIndex(h => h === handlers)
    i > -1 && KeyboardHandlers.keydownHandlers.splice(i, 1)
  }

  static addKeyup(handlers: KeyboardHandlersType): void {
    KeyboardHandlers.keyupHandlers.push(handlers)
  }

  static removeKeyup(handlers: KeyboardHandlersType): void {
    const i = KeyboardHandlers.keyupHandlers.findIndex(h => h === handlers)
    i > -1 && KeyboardHandlers.keyupHandlers.splice(i, 1)
  }

  static dispose(): void {
    this.keydownHandlers = []
    this.keyupHandlers = []
  }

  private static keydownListeners(): (e: KeyboardEvent) => Promise<void> {
    return executeKeyboardListeners(KeyboardHandlers.keydownHandlers)
  }

  private static keyupListeners(): (e: KeyboardEvent) => Promise<void> {
    return executeKeyboardListeners(KeyboardHandlers.keyupHandlers)
  }
}

const executeKeyboardListeners =
  (handlers: KeyboardHandlersType[]) =>
  async (e: KeyboardEvent): Promise<void> => {
    let i = handlers.length - 1
    while (i >= 0 && !(await keyboardHandler(handlers[i])(e))) {
      i--
    }
  }
